import React from 'react';
import { Container, Row, Col, Card, Pagination } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import "../assets/styles/CaseStudiesData.css";

const caseStudies = [
    {
        img: './assets/appDev.png',
        title: 'Online Education By Skill Boost',
        description: 'Async Vibe MEA partnered with Alfardan Group Perfecting the art of financial consolidation',
    },
    {
        img: './assets/appDev.png',
        title: 'Online Education By Skill Boost',
        description: 'Async Vibe MEA partnered with Alfardan Group Perfecting the art of financial consolidation',
    },
    {
        img: './assets/appDev.png',
        title: 'Property Portal',
        description: 'Async Vibe MEA partnered with Alfardan Group Perfecting the art of financial consolidation',
    },
    {
        img: './assets/appDev.png',
        title: 'Property Portal',
        description: 'Async Vibe MEA partnered with Alfardan Group Perfecting the art of financial consolidation',
    },
];

const PortfolioData = () => {
    const navigate = useNavigate();

    const handleReadMore = () => {
        // Navigate to blogs details page
        navigate('/blogs/Details');
    };

    return (
        <Container className="case-studies-container">
            <Row>
                {caseStudies.map((study, index) => (
                    <Col md={6} sm={12} key={index} className="case-study-card">
                        <Card>
                            <Card>
                                <Card.Body className="text-center">
                                    <Card.Img variant="top" src={study.img} style={{ height: '300px', width: '500px', objectFit: 'cover' }} />
                                </Card.Body>
                            </Card>

                            <Card.Body>
                                <Card.Title className='case-data-title'>{study.title}</Card.Title>
                                <Card.Subtitle className='case-data-description'>{study.description}</Card.Subtitle>
                                <button 
                                    className="read-more" 
                                    onClick={handleReadMore}
                                >
                                    READ MORE →
                                </button>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>
            <div className="pagination-container">
                <Pagination>
                    <Pagination.Prev disabled />
                    <Pagination.Item active>{1}</Pagination.Item>
                    <Pagination.Item>{2}</Pagination.Item>
                    <Pagination.Next />
                </Pagination>
            </div>
        </Container>
    );
};

export default PortfolioData;

